<template lang="pug">
  .body
    .modal.is-active(key="modal-editar",v-if="isModalActive")
      .modal-background(@click="closeModalActive")
      .box.position-relative.has-text-left.margin-right-10.margin-left-10
        div
          span.name {{ item.descripcionAlgoritmo | capitalize }}: {{ item.nombreEmpleado }}
        div(v-if="item.classes === 'solicitud-permisos' || item.classes === 'permisos'")
          span.text-small Tipo:&nbsp;
          span {{ item.descripcionTipo }}
        div
          span.text-small Fecha{{ item.desde === item.hasta ? '' : 's'}}:&nbsp;
          span {{ item.desde }}&nbsp
          span(v-if="item.desde !== item.hasta") - {{ item.hasta }}
        div(v-if="item.horaDesde")
          span.text-small Horas:&nbsp;
          span {{ item.horaDesde }} - {{ item.horaHasta }}
        div(v-if="item.classes.includes('solicitud')")
          span.text-small Estado:&nbsp;
          span {{ item.descripcionEstado }}
        div(v-if="item.classes.includes('solicitud') || item.classes === 'vacaciones'")
          span.text-small Creación solicitud:&nbsp;
          span {{ item.fechaCreacionSolicitud }}

    .is-overlay(v-if="isLoading")
      loading
    .flex.mb-5
      .flex.flex-1.filtros-check
        .control.flex(v-if="perfilVacaciones === 'recursos humanos'")
          input.checkbox(
            type="checkbox",
            :checked="verTodos"
            @change="verTodosChanged"
          )
          span.ml-5.asc Ver todos los empleados
        .control.flex.ml-15
          input.checkbox(
            type="checkbox",
            :checked="meIncluyo"
            @change="meIncluyoChanged"
          )
          span.ml-5.asc Incluir mi información
        .control.flex.ml-15
          input.checkbox(
            type="checkbox",
            :checked="verSolicitudesAprobadas"
            @change="verSolicitudesAprobadasChanged"
          )
          span.ml-5.asc Ver solo aprobadas
      //- hacer una leyenda con los colores de las clases
      .flex.flex-1.aic.mb-5.leyenda
        div.seen-vacaciones
          span Vacaciones
        div.seen-solicitud-vacaciones
          span Solicitud de Vacaciones
        div.seen-permisos
          span Permisos
        div.seen-solicitud-permisos
          span Solicitud de Permisos


    calendar-view.theme-default.holiday-us-traditional.holiday-us-official(
      :show-date='showDate'
      :items='lista'
      :startingDayOfWeek='1'
      @click-item='onItemClick'
      :periodChangedCallback='fetch'
      )
      calendar-view-header(slot='header' slot-scope='t' :header-props='t.headerProps' @input='setShowDate' )

</template>

<script>
import { apiGet, notify } from '../util/general'
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
require('vue-simple-calendar/static/css/default.css')
require('vue-simple-calendar/static/css/holidays-us.css')
export default {
  name: 'lista_equipo_vacaciones_component',
  data () {
    return {
      lista: [],
      codigoLogueadoJefe:localStorage.getItem('codigo') + '',
      perfilVacaciones: localStorage.getItem('perfilVacaciones'),
      isLoading: false,
      isShowingJefeDirecto: true,
      showDate: new Date(),
      periodStart: '',
      periodEnd: '',
      isModalActive: false,
      items: [
        {id: 1, startDate: '2024-01-01', endDate: '2024-01-02', classes:'vacaciones', title: 'Marco Torres'},
        {id: 2, startDate: '2024-01-03', endDate: '2024-01-04', classes:'solicitud-vacaciones', title: 'Juan Perez'},
        {id: 3, startDate: '2024-01-05', endDate: '2024-01-06', classes:'permisos', title: 'Maria Rodriguez'},
        {id: 4, startDate: '2024-01-07', endDate: '2024-01-08', classes:'solicitud-permisos', title: 'Jose Gomez'},
        {id: 5, startDate: '2024-01-09', endDate: '2024-01-10', style:'background-color: #fff !important;', title: 'Carlos Sanchez'},
        {id: 6, startDate: '2024-01-01', endDate: '2024-01-05', style:'background-color: #fff !important;', title: 'Luisa Perez'}
      ],
      item:{},
      verTodos: false,
      meIncluyo: true,
      creadoComponente: false,
      verSolicitudesAprobadas: false
    }
  },
  components: {
    CalendarView,
    CalendarViewHeader
  },
  created () {
    if (this.perfilVacaciones === 'recursos humanos') {
      this.verTodos = true
      this.meIncluyo = false
    }
    this.creadoComponente = true
  },
  methods: {
    verTodosChanged () {
      this.verTodos = !this.verTodos
      if (this.verTodos) {
        this.meIncluyo = false
      }
      this.fetch()
    },
    meIncluyoChanged () {
      this.meIncluyo = !this.meIncluyo
      if (this.meIncluyo) {
        this.verTodos = false
      }
      this.fetch()
    },
    verSolicitudesAprobadasChanged () {
      this.verSolicitudesAprobadas = !this.verSolicitudesAprobadas
      this.fetch()
    },
    setShowDate (d) {
      this.showDate = d;
    },
    onItemClick (item, e) {
      var vm = this
      vm.isModalActive = true
      vm.item = item.originalItem
    },
    closeModalActive () {
      this.isModalActive = false
    },
    fetch (obj) {
      var vm = this
      vm.isLoading = true

      var periodStart = ''
      var periodEnd = ''

      if (obj && obj.displayFirstDate) {
        periodStart = obj.displayFirstDate
        periodEnd = obj.displayLastDate
        vm.periodStart = obj.displayFirstDate
        vm.periodEnd = obj.displayLastDate
      } else {
        periodStart = vm.periodStart
        periodEnd = vm.periodEnd
      }

      var objSend = {
        desde: periodStart,
        hasta: periodEnd,
        meIncluyo: vm.meIncluyo,
        verSolicitudesAprobadas: vm.verSolicitudesAprobadas
      }
      if (vm.perfilVacaciones === 'recursos humanos') {
        objSend.verTodos = vm.verTodos
      }

      apiGet(vm, '/empleado/obtener/cascada/calendario', objSend, function (data) {
        vm.lista = data.lista
        if (!vm.creadoComponente && vm.perfilVacaciones === 'recursos humanos') {
          vm.meIncluyo = data.meIncluyoCheckbox
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        vm.creadoComponente = false
        if (vm.verTodos) {
          vm.meIncluyo = false
        }
        if (vm.meIncluyo) {
          vm.verTodos = false
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>

  .seen-vacaciones
    background-color: #FF9800;
    padding: 0px 42px;
    margin-top: 3px;
    border-radius: 4px;
    color: #333;
  .seen-solicitud-vacaciones
    background-color: #f7d4a1;
    padding: 0px 4px;
    margin-top: 3px;
    border-radius: 4px;
    color: #333;
  .seen-solicitud-permisos
    background-color: #aac3eb;
    padding: 0px 10px;
    margin-top: 3px;
    border-radius: 4px;
    color: #333;
  .seen-permisos
    background-color: #5390f3;
    padding: 0px 48px;
    margin-top: 3px;
    border-radius: 4px;
    color: #333;
  .leyenda
    justify-content: space-evenly;
    flex-wrap: wrap;
    padding: 10px;
  .margin-left-10
    margin-left 10px
  .is-overlay
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
  .text-small
    font-size 12px
    color #9a9a9a
  .name
    font-size: 16px;

  >>> .vacaciones
    background-color: #FF9800 !important
  >>> .solicitud-vacaciones
    background-color: #f7d4a1 !important
  >>> .permisos
    background-color: #5390f3 !important
  >>> .solicitud-permisos
    background-color: #aac3eb !important
  .cv-wrapper
    height: calc(100dvh - 125px);

  @media (max-width: 607px)
    .filtros-check
      flex-direction: column;
      max-width: fit-content;
      .control
        margin-left: 0px !important;
</style>




// WEBPACK FOOTER //
// Component_Reporte_Calendario.vue?897f193c